import SortableDynamicTable from "./SortableDynamicTable";
import { ReactElement } from "react";

const SortableStripedTable = <T,>({
  values,
  columns,
}: {
  values: ContractTerms;
  columns: ColumnDefinition<T>[];
}): ReactElement => (
  <SortableDynamicTable
    colorScheme="gray"
    variant="striped"
    values={values}
    columns={columns}
    tablePaddingX={{
      _last: { paddingRight: 3 },
    }}
  />
);

export default SortableStripedTable;
